import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { developmentGuard } from './core/guards/development.guard';
import { pendingDownloadGuard } from './core/guards/pending-download.guard';
import { eRole } from '../environments/environment.prod';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent)
    },
    {
        path: 'start-digital-app',
        loadComponent: () => import('./start-digital-app/start-digital-app.component').then((m) => m.StartDigitalAppComponent)
    },
    {
        path: 'app-download',
        data: { roles: [eRole.user] },
        canActivate: [authGuard],
        canDeactivate: [pendingDownloadGuard],
        loadComponent: () => import('./features/app-download/app-download.component').then((m) => m.AppDownloadComponent)
    },
    {
        path: 'app-feature-highlights',
        data: { roles: [eRole.user] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/app-feature-highlights/app-feature-highlights/app-feature-highlights.component').then((m) => m.AppFeatureHighlightsComponent)
    },
    {
        path: 'customer-overview',
        data: { roles: [eRole.bihlerAdmin] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/customer-list/customer-list.component').then((m) => m.CustomerListComponent)
    },
    {
        path: 'customer-detailview/:id',
        data: { editCustomer: true, roles: [eRole.bihlerAdmin] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/customer-detailview/customer-detailview/customer-detailview.component').then((m) => m.CustomerDetailviewComponent)
    },
    {
        path: 'customer-detailview',
        data: { editCustomer: false, roles: [eRole.bihlerAdmin] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/customer-detailview/customer-detailview/customer-detailview.component').then((m) => m.CustomerDetailviewComponent)
    },
    {
        path: 'docuconversion',
        loadComponent: () => import('./features/docuconversion/docuconversion.component').then((m) => m.DocuconversionComponent)
    },
    {
        path: 'crossReferenceSearch',
        loadComponent: () => import('./features/cross-reference-search/cross-reference-search.component').then((m) => m.CrossReferenceSearchComponent)
    },
    {
        path: 'nc-aggregate-lubrication',
        loadComponent: () => import('./features/nc-aggregate-lubrication/nc-aggregate-lubrication.component').then((m) => m.NcAggregateLubricationComponent)
    },
    {
        path: 'release-note-history',
        data: { roles: [eRole.user] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/release-note-history/release-note-history/release-note-history.component').then((m) => m.ReleaseNoteHistoryComponent)
    },
    {
        path: 'software-vulnerability',
        data: { roles: [eRole.user] },
        canActivate: [authGuard, developmentGuard],
        loadComponent: () => import('./features/software-vulnerability/software-vulnerability/software-vulnerability.component').then((m) => m.SoftwareVulnerabilityComponent)
    },
    {
        path: 'user-management-overview',
        data: { roles: [eRole.customerAdmin] },
        canActivate: [authGuard],
        loadComponent: () => import('./features/user-management/user-management-overview/user-management-overview.component').then((m) => m.UserManagementOverviewComponent)
    },
    {
        path: 'admin-panel',
        data: { roles: [eRole.bihlerAdmin], users: ['mathias.wilhelm@bihler.de', 'markus.haeringer@bihler.de'] },
        canActivate: [authGuard],
        loadComponent: () => import('./admin-panel.component/admin-panel.component').then((m) => m.AdminPanelComponent)
    },
    {
        path: 'impressum',
        loadComponent: () => import('./impressum/impressum.component').then((m) => m.ImpressumComponent)
    },
    {
        path: 'imprint',
        loadComponent: () => import('./imprint/imprint.component').then((m) => m.ImprintComponent)
    },
    {
        path: 'datenschutz',
        loadComponent: () => import('./datenschutz/datenschutz.component').then((m) => m.DatenschutzComponent)
    },
    {
        path: 'privacy',
        loadComponent: () => import('./privacy/privacy.component').then((m) => m.PrivacyComponent)
    },
    { path: '**', redirectTo: 'home', pathMatch: 'full' }
];